import { endOfMonth, endOfWeek, endOfYesterday, startOfDay, startOfMonth, startOfWeek, startOfYear, startOfYesterday, subHours, subMonths, subWeeks } from 'date-fns'
import { Select } from '..'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { PeriodType } from '@indigohive/cogfy-types'
import clsx, { ClassValue } from 'clsx'

export type DateSelectProps = {
  setStartDate: (date?: Date) => void
  setEndDate: (date?: Date) => void
  periodType: PeriodType
  setPeriodType: (periodType: PeriodType) => void
  setOpen: (open: boolean) => void
  className?: ClassValue
}

export function DateSelect (props: DateSelectProps) {
  const { setStartDate, setEndDate, periodType, setPeriodType, setOpen, className } = props

  const { t } = useTranslation()

  useState(() => {
    setStartDate(startOfDay(new Date()))
    setEndDate(new Date())
  })

  return (
    <div className={clsx('flex w-1/2 flex-col', className)}>
      <h2 className="font-medium textarea-md text-gray-500">{t('filters:Period')}</h2>
      <Select
        value={periodType}
        className="-mb-1"
        options={[
          { label: t('filters:no filter'), value: 'noFilter' },
          { label: t('filters:this hour'), value: 'hour' },
          { label: t('filters:today'), value: 'today' },
          { label: t('filters:yesterday'), value: 'yesterday' },
          { label: t('filters:this week'), value: 'week' },
          { label: t('filters:last week'), value: 'lastWeek' },
          { label: t('filters:this month'), value: 'month' },
          { label: t('filters:last month'), value: 'lastMonth' },
          { label: t('filters:this year'), value: 'year' },
          { label: t('filters:custom'), value: 'custom' }
        ]}
        onChange={(e) => {
          const dates = handleDates(e.target.value as PeriodType)
          setStartDate(dates ? dates[0] : undefined)
          setEndDate(dates ? dates[1] : undefined)
          setPeriodType(e.target.value as PeriodType)
          if (e.target.value === 'custom') {
            setOpen(true)
          }
        }}
      />
    </div>
  )
}

function handleDates (value: PeriodType): Date[] | undefined {
  if (value === 'noFilter') {
    return undefined
  } else if (value === 'hour') {
    return [subHours(new Date(), 1), new Date()]
  } else if (value === 'today') {
    return [startOfDay(new Date()), new Date()]
  } else if (value === 'yesterday') {
    return [startOfYesterday(), endOfYesterday()]
  } else if (value === 'week') {
    return [startOfWeek(new Date()), new Date()]
  } else if (value === 'lastWeek') {
    return [subWeeks(startOfWeek(new Date()), 1), subWeeks(endOfWeek(new Date()), 1)]
  } else if (value === 'month') {
    return [startOfMonth(new Date()), new Date()]
  } else if (value === 'lastMonth') {
    return [subMonths(startOfMonth(new Date()), 1), endOfMonth(subMonths(new Date(), 1))]
  } else if (value === 'year') {
    return [startOfYear(new Date()), new Date()]
  }
}
